module.exports = __webpack_public_path__ + "img/solution-software-system-pic-5.e1ace0be.png";